import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { FormulaMaterial } from '@/types/formula';

export const useFormulaMaterials = (formulaId: string) => {
  const fetchFormulaMaterials = async (): Promise<FormulaMaterial[]> => {
    // For now, return mock data
    // In a real app, this would be a Supabase query
    const mockMaterials: FormulaMaterial[] = [
      {
        id: '1',
        formula_id: formulaId,
        name: 'Titanium Dioxide',
        type: 'chemical',
        percentage: 15.5,
        cas_number: '13463-67-7',
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString()
      },
      {
        id: '2',
        formula_id: formulaId,
        name: 'Acrylic Resin',
        type: 'raw',
        percentage: 35.2,
        cas_number: null,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString()
      },
      {
        id: '3',
        formula_id: formulaId,
        name: 'Water',
        type: 'chemical',
        percentage: 40.0,
        cas_number: '7732-18-5',
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString()
      },
      {
        id: '4',
        formula_id: formulaId,
        name: 'Surfactant',
        type: 'chemical',
        percentage: 9.3,
        cas_number: '68439-57-6',
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString()
      }
    ];
    
    return mockMaterials;
  };

  return useQuery({
    queryKey: ['formula-materials', formulaId],
    queryFn: fetchFormulaMaterials,
    enabled: !!formulaId,
  });
};